import { isRTL } from 'core/services/language';

interface TableCustomCellProps {
	title: string;
	subTitle?: string;
	imgSrc?: string;
	subTitleStyles?: React.CSSProperties;
}

function TableCustomCell({ title, subTitle, imgSrc , subTitleStyles }: TableCustomCellProps) {
	return (
		<span className="d-flex align-items-center gap-3">
			<span style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
				{imgSrc ? (
					<img src={imgSrc} alt={title} style={{ width: 45, height: 45, borderRadius: '50%', objectFit: 'cover' }} />
				) : (
					<span
						style={{
							background: '#E8FFF3',
							color: '#50CD89',
							borderRadius: '50%',
							fontWeight: 600,
							width: 45,
							height: 45,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}>
						{isRTL() ? title?.slice(0, 2).toUpperCase().split('').join(' ') : title?.slice(0, 2).toUpperCase()}
					</span>
				)}
				<div>
					<p style={{ marginBottom: 0, fontWeight: 600, color: '#3F4254' }}>{title}</p>
					{subTitle && <span style={{ marginBottom: 0, fontWeight: 500, color: '#aaa' , ...subTitleStyles }}>{subTitle}</span>}
				</div>
			</span>
		</span>
	);
}

export default TableCustomCell;
